/**
 * Captura parâmetros UTM e IDs de rastreamento da URL
 */
export const captureUTMParams = () => {
    const urlParams = new URLSearchParams(window.location.search);

    return {
        utmSource: urlParams.get('utm_source') || null,
        utmMedium: urlParams.get('utm_medium') || null,
        utmCampaign: urlParams.get('utm_campaign') || null,
        utmContent: urlParams.get('utm_content') || null,
        utmTerm: urlParams.get('utm_term') || null,
        gclid: urlParams.get('gclid') || null,
        fbclid: urlParams.get('fbclid') || null
    };
};

/**
 * Armazena parâmetros UTM em sessionStorage
 */
export const storeUTMParams = (params) => {
    if (params && Object.values(params).some(v => v !== null)) {
        sessionStorage.setItem('utm_params', JSON.stringify(params));
    }
};

/**
 * Recupera parâmetros UTM armazenados
 */
export const getStoredUTMParams = () => {
    const stored = sessionStorage.getItem('utm_params');
    return stored ? JSON.parse(stored) : null;
};

/**
 * Limpa parâmetros UTM armazenados
 */
export const clearUTMParams = () => {
    sessionStorage.removeItem('utm_params');
};

/**
 * Classifica a origem com base nos parâmetros
 */
export const classifySource = (params) => {
    if (!params) return 'direto';

    if (params.gclid) return 'google';
    if (params.fbclid) return 'facebook';
    if (!params.utmSource && !params.utmMedium && !params.utmCampaign) return 'direto';

    return 'outros';
};
